<script setup lang="ts">
import { changeLocale } from '@formkit/vue'

const app = useNuxtApp()
const { region, redirectToRegion } = useRegion()
const { locale } = useI18n()

const regionLocales = [
  // { id: 'global_en', label: 'Global (English)', region: 'global', locale: 'en' },
  // { id: 'global_zh-cn', label: '全球（中文）', region: 'global', locale: 'zh-cn' },
  { id: 'china_en', label: 'China (English)', region: 'china', locale: 'en' },
  { id: 'china_zh-cn', label: '中国（中文）', region: 'china', locale: 'zh-cn' },
]

const currentRegionLocale = computed(() => {
  return regionLocales.find((rl) => {
    return rl.region === region && rl.locale === locale.value
  })
})

const availableRegionLocales = computed(() => {
  const results = regionLocales.filter((rl) => {
    return rl.id !== currentRegionLocale.value?.id
  })

  results.sort((a, b) => {
    if (a.region === region && b.region !== region) return -1
    if (a.region !== region && b.region === region) return 1

    return 0
  })

  return results
})

function changeRegion(toRegion: string, toLocale: string) {
  if (toRegion === region) {
    app.$i18n.setLocale(toLocale)
    changeLocale(toLocale)
    reloadNuxtApp({ force: true })
    return
  }

  return redirectToRegion({ region: toRegion, path: ''})
}
</script>

<template>

  <div class="locale-changer">
    <div class="selector">
      <button class="icon">
        <Icon name="language" color="#ffffff" />
      </button>
      <div class="label">{{ currentRegionLocale?.label }}</div>
    </div>

    <div class="options">
      <button v-for="rl of availableRegionLocales" :key="rl.id" @click="changeRegion(rl.region, rl.locale)">
        {{ rl.label }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.locale-changer {
  position: relative;
  cursor: pointer;

  button {
    padding: 0.5rem;
    border: none;
    color: $color-white;
    font-size: 0.85rem;
    background: none;
    cursor: pointer;

    &:hover {
      background-color: rgba($color-white, 0.1);
    }
  }

  .selector {
    display: flex;
    align-items: center;
    color: $color-white;
    font-size: 0.75rem;

    button {
      padding: 0.25rem;
    }
  }

  .label {
    display: none;
    margin-left: 0.25rem;

    @media (min-width: $breakpoint-md) {
      display: block;
    }
  }

  .options {
    position: absolute;
    width: 10rem;
    right: 0;
    display: none;
    flex-direction: column;
    background-color: rgba($color-dark-gray, 0.9);
    border: 1px solid $color-medium-gray;
    border-radius: $border-radius-rounded;
    overflow: hidden;
    cursor: pointer;

    & > * {
      flex: 1 1 auto;
    }
  }

  &:hover .options {
    display: flex;
  }
}
</style>
